import type { Option } from '@usealloy/component-library';

export const INTELLICHECK_PREFIX = 'fields.IntellicheckIDVerification';

export const QR_BREAKPOINT = `${INTELLICHECK_PREFIX}.intellicheckidv_qr_breakpoint_px`;
export const CAPTURE_LANGUAGE = `${INTELLICHECK_PREFIX}.intellicheckidv_capture_language`;

export const DOCUMENT_TYPE = `${INTELLICHECK_PREFIX}.intellicheckidv_document_type`;
export const SIGNALS = `${INTELLICHECK_PREFIX}.intellicheckidv_signals`;
export const DEVICE_VALIDATION = `${INTELLICHECK_PREFIX}.intellicheckidv_device_validation`;
export const PURPOSE = `${INTELLICHECK_PREFIX}.intellicheckidv_purpose`;

export const TIME_TO_LIVE = `${INTELLICHECK_PREFIX}.intellicheckidv_ttl`;
export const RETURN_IMAGES = `${INTELLICHECK_PREFIX}.intellicheckidv_return_images`;

export const LANGUAGE_OPTIONS: Option[] = [
  { label: 'English - US', value: 'en-us' },
  { label: 'French - Canada', value: 'fr-ca' },
  { label: 'Spanish - Mexico', value: 'es-mx' },
];

export const DOCUMENT_TYPE_OPTIONS: Option[] = [
  { label: 'North American Driver\'s License', value: 'na_dl' },
  { label: 'Passport', value: 'passport' },
  { label: 'Other', value: 'other' },
];

export const SIGNALS_OPTIONS: Option<{ displayLabel: string }>[] = [
  {
    label: 'Barcode check (idcheck)',
    value: 'idcheck',
    meta: { displayLabel: 'Barcode check' },
  },
  {
    label: 'Document scan (ocr_scan)',
    value: 'ocr_scan',
    meta: { displayLabel: 'Document scan' },
  },
  {
    label: 'Document verification (ocr_match)',
    value: 'ocr_match',
    meta: { displayLabel: 'Document verification' },
  },
  {
    label: 'Selfie (selfie)',
    value: 'selfie',
    meta: { displayLabel: 'Selfie' },
  },
  {
    label: 'Document liveness (document_liveness_idrnd)',
    value: 'document_liveness_idrnd',
    meta: { displayLabel: 'Document liveness' },
  },
];

export const REQUIRED_SIGNALS_BY_DOCUMENT_TYPE: Record<string, string> = {
  na_dl: 'idcheck',
  passport: 'ocr_scan',
  other: 'ocr_scan',
};

export const LOCK_TOOLTIPS_BY_DOCUMENT_TYPE: Record<string, string> = {
  na_dl: "This option is required for Driver's Licenses.",
  passport: 'This option is required for Passports and Other document types.',
  other: 'This option is required for Passports and Other document types.',
};
